import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useApi from '../../api/useApi';
import NewNotification from '../../components/NewNotification';
import { useStateValue } from '../../ContextApi/StateProvider';
import '../../scrollbar.css';

const Login = () => {
  const [reset, setReset] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState();
  const [message, setMessage] = useState();
  const [{ user }, dispatch] = useStateValue();
  const intervalId = setInterval(function () {
    if (!navigator.onLine) {
      setType('warning');
      setMessage('Check your internet connection');
      setNotification(true);
    }
  }, 2000);
  const history = useHistory();

  const [{ isLoading, isError, data }, login] = useApi();

  const [formData, setFormData] = useState({
    emailId: '',
    userSecret: '',
  });
  const [email, setEmail] = useState('');
  const [resetState, resetPassword] = useApi();
  const [state, changePassword] = useApi();
  const [displayPwd, setDisplayPwd] = useState(false);

  const [newPwdData, setNewPwdData] = useState({
    emailId: '',
    userSecret: '',
    code: '',
  });

  useEffect(() => {
    // if (sessionStorage.getItem('user') !== null) {
    if (sessionStorage.user && JSON.parse(sessionStorage.user).token) {
      history.replace('/dashboard');
    }
    // }
  }, []);

  const handleSignIn = (e) => {
    e.preventDefault();
    login(`/login`, 'POST', formData);
  };

  useEffect(() => {
    if (!isLoading && !isError && data) {
      if (data.token) {
        sessionStorage.user = JSON.stringify(data);

        dispatch({
          type: 'USER_DATA',
          user: data.user,
        });

        history.replace('/dashboard');
      }
    }
    if (isError) {
      setType('error');
      if (data) {
        setMessage(data);
      } else {
        setMessage('error', 'App is facing network related issues.');
      }
      // setMessage(data);
      setNotification(true);
    }
  }, [isLoading, isError, data]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleResetPassword = (e) => {
    e.preventDefault();
    resetPassword('/resetPassword', 'POST', { emailId: email });
  };

  useEffect(() => {
    if (!resetState.isLoading && !resetState.isError && resetState.data) {
      setConfirmPassword(true);
    }
    if (resetState.isError && resetState.isLoading) {
      setType('error');
      setMessage(resetState.data);
      setNotification(true);
    }
  }, [resetState]);

  const handleChangePwd = (e) => {
    e.preventDefault();
    if (newPwdData.userSecret && newPwdData.userSecret !== newPwdData.confirmPassword) {
      setType('error');
      setMessage('Password and Confirm Password should match.');
      setNotification(true);
      return;
    }
    newPwdData.emailId = email;
    changePassword(`/confirmPassword`, 'POST', newPwdData);
  };

  useEffect(() => {
    if (state.data) {
      setReset(false);
      setConfirmPassword(false);
      setType('success');
      setMessage('Password changed successfully');
      setNotification(true);
    }

    if (state.isError && state.isLoading) {
      setType('error');
      setMessage(state.data);
      setNotification(true);
    }
  }, [state]);

  const handleChange2 = (e) => {
    setNewPwdData({ ...newPwdData, [e.target.name]: e.target.value });
  };
  const alertMsg = (msg) => {
    setNotification(msg);
  };

  return (
    <div className="fixed w-full h-full backgroundImg max-w-full">
      {notification && <NewNotification type={type} message={message} alertMsg={alertMsg} />}
      {/* <div
        className="fixed  w-full h-full bg-no-repeat bg-cover max-w-full"
        style={{ background: "url('./assets/img/BG.jpeg')" }}
      > */}
      {!reset && (
        <div className="block m-auto mt-14 text-center w-4/12 sm:w-8/12 md:w-6/12 lg:w-4/12">
          <h2 className="text-xl font-medium text-white">Let's get started now!</h2>
          <div className="bg-white mx-0 lg:mx-4 my-4 shadow-md rounded-xl text-black mobile_login">
            <img src="assets/img/Logo.svg" className="w-1/3 block m-auto pt-8" alt="" />
            <p className="my-6 text-xl font-semibold" style={{ color: '#737373' }}>
              Login to your account
            </p>
            <div className="p-6 pt-4 rounded-xl">
              <form className="mb-4" onSubmit={handleSignIn} autoComplete="off">
                <div className="text-sm relative border rounded-lg font-medium">
                  {/* <label htmlFor="username" className="block text-primary absolute bg-white left-3 -top-2.5">
                    Email
                  </label> */}
                  <input
                    type="email"
                    autoFocus
                    id="username"
                    className="inputBox px-4 py-3 shadow-md focus:outline-none w-full"
                    placeholder="Username"
                    onChange={handleChange}
                    name="emailId"
                  />
                </div>
                <div className="my-5 text-sm relative border rounded-lg font-medium">
                  {/* <label htmlFor="password" className="block text-primary absolute bg-white left-3 -top-2.5">
                    Password
                  </label> */}
                  <input
                    type={displayPwd ? 'text' : 'password'}
                    id="password"
                    className="inputBox px-4 py-3 shadow-md focus:outline-none w-full"
                    placeholder="Password"
                    onChange={handleChange}
                    name="userSecret"
                    pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*]).{8,}"
                    title="Must contain at least one number and one uppercase and lowercase letter and one special character(!@#), and at least 8 or more characters"
                  />
                  {displayPwd ? (
                    <img
                      src="assets/img/HidePassword.svg"
                      className="absolute right-2 top-4 w-4"
                      onClick={() => setDisplayPwd((prev) => !prev)}
                    />
                  ) : (
                    <img
                      src="assets/img/ShowPassword.svg"
                      className="absolute right-2 top-4 w-4"
                      onClick={() => setDisplayPwd((prev) => !prev)}
                    />
                  )}
                  <img
                    src="assets/img/ShowPassword.svg"
                    className="absolute right-2 top-4 w-4"
                    onClick={() => setDisplayPwd((prev) => !prev)}
                  />
                </div>
                {isLoading ? (
                  <img src="assets/img/loader.svg" className=" w-14 mx-auto" alt="" />
                ) : (
                  <button
                    type="submit"
                    style={{ background: '#0F7FB0', boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)', borderRadius: '5px' }}
                    className="block text-white text-center p-3 duration-300 rounded-lg hover:bg-primary w-full focus:outline-none"
                  >
                    Login
                  </button>
                )}
              </form>

              <a
                href="#"
                className="text-role w-full block text-right underline mt-4 text-xs md:hover:underline"
                onClick={() => {
                  setReset(true);
                }}
              >
                Reset Password
              </a>
            </div>
          </div>
        </div>
      )}

      {reset && (
        <div className="absolute left-1/3 w-1/3 top-1/4 text-center">
          <div className="absolute bg-white w-9/12 mx-14 my-8 shadow-md rounded-xl text-black mobile_login">
            <h1 className="text-xl font-medium text-secondary pt-7 pb-5">Reset Password</h1>
            <p className="text-xs font-normal text-parameter">
              Please enter your email address and <br /> we'll send you a link to reset your password.
            </p>
            <div className="pt-5 pb-4 px-6 rounded-xl">
              <form className="mt-6 mb-4" onSubmit={handleResetPassword}>
                <div className=" my-5 text-sm relative border border-primary rounded-lg font-medium">
                  <label htmlFor="username" className="block text-primary absolute bg-white left-3 -top-2.5">
                    Email
                  </label>
                  <input
                    type="email"
                    autoFocus
                    className="rounded-lg bg-white px-4 py-3 focus:outline-none w-full"
                    placeholder="Enter your email"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                {resetState.isLoading ? (
                  <img src="assets/img/loader.svg" className=" w-14 mx-auto" alt="" />
                ) : (
                  <button
                    type="submit"
                    className="block text-center text-white bg-primary p-3 duration-300 rounded-lg hover:bg-primary w-full focus:outline-none"
                  >
                    Reset Password
                  </button>
                )}
              </form>

              <a
                href="#"
                className="text-role w-full block text-right underline mt-4 text-xs md:hover:underline"
                onClick={() => {
                  setReset(false);
                }}
              >
                Login
              </a>
            </div>
          </div>
        </div>
      )}

      {confirmPassword && (
        <div className="absolute left-1/3 w-1/3 top-1/4 text-center">
          <div className="absolute bg-white w-9/12 mx-14 my-8 shadow-md rounded-xl text-black">
            <h1 className="text-2xl font-medium text-secondary pt-7">Password Reset</h1>
            <div className="pt-2 px-6 rounded-xl">
              <form className="mt-6" onSubmit={handleChangePwd}>
                <div className=" my-5 text-sm relative border border-primary rounded-lg font-medium">
                  <label htmlFor="username" className="block text-primary absolute bg-white left-3 -top-2.5">
                    Email
                  </label>
                  <input
                    type="email"
                    autoFocus
                    name="emailId"
                    value={email}
                    className="rounded-lg bg-white px-4 py-3 focus:outline-none w-full text-textBox"
                    placeholder="Email"
                    disabled
                  />
                </div>

                <div className=" my-5 text-sm relative border border-primary rounded-lg font-medium">
                  <label htmlFor="username" className="block text-primary absolute bg-white left-3 -top-2.5">
                    Code
                  </label>
                  <input
                    type="text"
                    name="code"
                    className="rounded-lg bg-white px-4 py-3 focus:outline-none w-full text-textBox"
                    placeholder="Enter code received in mail"
                    onChange={handleChange2}
                  />
                </div>

                <div className=" my-5 text-sm relative border border-primary rounded-lg font-medium">
                  <label htmlFor="username" className="block text-primary absolute bg-white left-3 -top-2.5">
                    Password
                  </label>
                  <input
                    type="password"
                    autoFocus
                    name="userSecret"
                    className="rounded-lg bg-white px-4 py-3 focus:outline-none w-full text-textBox"
                    placeholder="Password"
                    onChange={handleChange2}
                    pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*]).{8,}"
                    title="Must contain at least one number and one uppercase and lowercase letter and one special character(!@#), and at least 8 or more characters"
                  />
                </div>
                <div className=" my-5 text-sm relative border border-primary rounded-lg font-medium">
                  <label htmlFor="username" className="block text-primary absolute bg-white left-3 -top-2.5">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    name="confirmPassword"
                    className="rounded-lg bg-white px-4 py-3 focus:outline-none w-full text-textBox"
                    placeholder="Confirm Password"
                    onChange={handleChange2}
                    pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*]).{8,}"
                    title="Must contain at least one number and one uppercase and lowercase letter and one special character(!@#), and at least 8 or more characters"
                    onBlur={(e) => {
                      if (newPwdData.userSecret && e.target.value && newPwdData.userSecret !== e.target.value) {
                        setType('error');
                        setMessage('Password and Confirm Password should match.');
                        setNotification(true);
                      }
                    }}
                  />
                </div>
                {state.isLoading ? (
                  <img src="assets/img/loader.svg" className=" w-14 mx-auto" alt="" />
                ) : (
                  <button
                    type="submit"
                    className="block text-center text-white bg-primary p-3 duration-300 rounded-lg hover:bg-primary w-full focus:outline-none"
                  >
                    Confirm Password
                  </button>
                )}
              </form>

              <button
                className="py-7 border-0 hover:border-0 text-xs focus:outline-none"
                onClick={() => {
                  setReset(false);
                  setConfirmPassword(false);
                }}
              >
                Login
              </button>
            </div>
          </div>
        </div>
      )}
      {/* </div> */}
      <div className="block w-full fixed bottom-12 text-center text-white">
        <img src="assets/img/tntlogo.svg" className="w-24 mx-auto" alt="" />
        <span className="mx-auto text-xs">© 2021. All Rights Reserved</span>
      </div>
      <div className="fixed bottom-0 right-8 text-md text-white font-bold">v2.0.3</div>
    </div>
  );
};

export default Login;
